import { cn } from "../utils/utils";
import React from "react";

export default function HoverUnderLine({
	children,
	className = "bg-h5",
}) {
	return (
		<div className="group">
			{children}
			<div
				className={cn(
					"h-1 w-0 group-hover:w-full  transition-all",
					className
				)}
			></div>
		</div>
	);
}
